import * as R from "ramda"
import React,
{ Component } from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"

import { GenericImportPage } from "@driftt/crm-components"
import {
  Div,
  H3,
  Li,
  Ul 
} from "@driftt/tide-core"
import { showTransientNotification } from "@driftt/traffic-control"
import {
  forceFetchFromMarketo,
  getMarketoLists,
  pauseMarketoLists,
  syncMarketoLists 
} from "api/imports"
import {
  getOrgMarketoAccessType,
  MarketoAccessTypes,
  shouldShowMarketoImports 
} from "utils/marketoAccess"

import MarketoImportTableConfig from "./MarketoImportTableConfig"

const MARKETO_SMART_LIST_SYNC_ERROR = `We could not export the smart lists in your request - you will need Bulk Lead Export API access for your account. Ask your Marketo account representative to add this!`

const fetchMarketoLists = async ({
  query,
  type 
}) => {
  const data = await getMarketoLists({
    query,
    listType: type 
  })

  return data.data
}

const fetchFromMarketoOnPageLoad = () => {
  return forceFetchFromMarketo({ force: false })
}

const fetchFromMarketo = () => {
  return forceFetchFromMarketo({ force: true })
}

const findSmartListErrors = syncResult => {
  const data = syncResult.data
  if (!data) {
    return []
  }

  const listIds = Object.keys(data)
  return listIds.filter(listId => {
    const errs = data[listId]["errors"]
    const smartListErrors = errs.filter(err => err.code === 1035 && R.contains("smartListId", err.message)) // marketo smart list permission error.
    return smartListErrors && smartListErrors.length > 0
  })
}

const ListTypes = [
  {
    key: "SMART",
    displayName: "Smart List ⚡️",
    displayNamePlural: "Smart Lists ⚡️",
    iconKey: "lightning-bolt"
  },
  {
    key: "STATIC",
    displayName: "Static List",
    displayNamePlural: "Static Lists",
    iconKey: "list-bullets"
  }
]

const ModalBody = () => (
  <Div className="pardot-import--modal-body">
    <H3>Marketo sync information</H3>
    <Ul>
      <Li>Imported lists will be saved as Drift segments</Li>
      <Li>Drift only syncs contacts that have a Munchkin cookie</Li>
      <Li>
        Your Marketo account needs permission to use the Bulk Lead Export API
      </Li>
    </Ul>
  </Div>
)

const mapDispatchToProps = dispatch => {
  return {
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

class MarketoImport extends Component {

  syncListsWithCheck = async (listIds) => {
    try {
      const syncListResult = await syncMarketoLists({ listIds })

      const listErrors = findSmartListErrors(syncListResult)
      if (listErrors && listErrors.length > 0) {
        this.props.showTransientNotification({
          type: "error",
          message: MARKETO_SMART_LIST_SYNC_ERROR
        })
      }
    } catch (e) {
      console.error(e)
    }
  }

  pauseListsWithCheck = async (listIds) => {
    try {
      await pauseMarketoLists({ listIds })
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    const hasAccess = getOrgMarketoAccessType() === MarketoAccessTypes.HAS_ACCESS_CONNECTED
    const showMarketoImports = shouldShowMarketoImports() && hasAccess

    if(!this.props.bootstrapComplete) {return null}

    if (!showMarketoImports) {
      return <Redirect to="/imports" />
    }

    return (
      <GenericImportPage
        title="Import Marketo Lists"
        integrationId="MARKETO"
        integrationDisplayName="Marketo"
        fetchLists={fetchMarketoLists}
        fetchInitialData={fetchFromMarketoOnPageLoad}
        refreshLists={fetchFromMarketo}
        syncLists={({ listIds }) => this.syncListsWithCheck(listIds)}
        pauseLists={({ listIds }) => this.pauseListsWithCheck(listIds)}
        listTypes={ListTypes}
        tableConfig={MarketoImportTableConfig}
        modalBody={ModalBody}
      />
    )
  }
}


export default connect(state => ({ bootstrapComplete: state.config.bootstrapComplete }), mapDispatchToProps)(MarketoImport)
